var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-2 border rounded p-2"},[_c('h5',{staticClass:"pl-2 mb-0"},[_c('small',{staticClass:"text-muted"},[_c('font-awesome-icon',{attrs:{"icon":"grip-lines"}})],1),_vm._v("\n    "+_vm._s(_vm.client.name)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }